import DealSetupAttachments from "./DealSetupAttachmentsModalContainer.legacy";

export default DealSetupAttachments;
